module.exports = __webpack_public_path__ + "static/media/Dobro - map icons_Centar Sokol d.o.o. icon (1).e9575f2e.svg";